import { getSpecies, STARTER_IDS } from '../game/data/species';
import { RISONANZA_COLOR, RISONANZA_LABEL } from '../game/data/risonanze';
import { battlerUrl } from './creatureArt';
import { el } from './dom';

/** Schermata di scelta del Lumine iniziale. */

export function chooseStarter(uiRoot: HTMLElement): Promise<string> {
  return new Promise((resolve) => {
    const overlay = el('div', 'overlay');
    const panel = el('div', 'panel');
    panel.append(
      el('h2', 'ui-title', 'Scegli il tuo primo Lumine'),
      el(
        'p',
        undefined,
        'La Dott.ssa Mira ha stabilizzato tre giovani Lumini: uno di loro ti accompagnerà come Custode di Faglia.',
      ),
    );

    const grid = el('div', 'starter-grid');
    for (const id of STARTER_IDS) {
      const species = getSpecies(id);
      const card = el('div', 'starter-card');
      const img = el('img');
      img.src = battlerUrl(species.id);
      img.alt = species.name;
      const tipo = el('span', 'tipo', RISONANZA_LABEL[species.risonanza]);
      tipo.style.background = RISONANZA_COLOR[species.risonanza];
      card.append(img, el('h3', undefined, species.name), tipo, el('p', undefined, species.description));
      card.addEventListener('click', () => {
        overlay.remove();
        resolve(id);
      });
      grid.appendChild(card);
    }
    panel.appendChild(grid);
    overlay.appendChild(panel);
    uiRoot.appendChild(overlay);
  });
}
